/** Maps built-in mill role slug to dashboard variant. */
const DEPARTMENT_ROLES = {
  boiler_foreman: "boiler",
  boiler_operator: "boiler",
  parboiled_foreman: "parboiled",
  parboiled_operator: "parboiled",
  milling_foreman: "milling",
  milling_operator: "milling",
};

const DEPARTMENT_PERMISSIONS = {
  boiler: "page.production_boiler",
  parboiled: "page.production_parboiled",
  milling: "page.production_milling",
};

const DEPARTMENT_LABELS = {
  boiler: "Boiler",
  parboiled: "Parboiled",
  milling: "Milling",
};

export function departmentForRole(role) {
  return DEPARTMENT_ROLES[role] || null;
}

export function isDepartmentRole(role) {
  return Boolean(departmentForRole(role));
}

export function isGuardRole(role) {
  return role === "guard";
}

export function isLabRole(role) {
  return role === "lab";
}

export function isWeighbridgeRole(role) {
  return role === "weighbridge";
}

export function isDepartmentForeman(role) {
  const dept = departmentForRole(role);
  return Boolean(dept && role === `${dept}_foreman`);
}

export function canAccessDepartmentDashboard(role, department) {
  return role === `${department}_foreman`;
}

export function departmentPermission(dept) {
  return DEPARTMENT_PERMISSIONS[dept] || null;
}

export function departmentLabel(dept) {
  return DEPARTMENT_LABELS[dept] || dept;
}

export function departmentWorkspacePath(dept) {
  return `/production/${dept}`;
}

export function departmentDashboardPath(dept) {
  return `/production/${dept}/dashboard`;
}

export function isProductionLoadingSupervisorRole(role) {
  return role === "production_loading_supervisor";
}

export function isStoreKeeperRole(role) {
  return role === "store_keeper";
}

export function homePathForRole(role) {
  if (isProductionLoadingSupervisorRole(role)) return "/";
  const dept = departmentForRole(role);
  if (!dept) return "/";
  if (isDepartmentForeman(role)) return departmentDashboardPath(dept);
  return departmentWorkspacePath(dept);
}

export function dashboardVariantForRole(role) {
  const dept = departmentForRole(role);
  if (dept && isDepartmentForeman(role)) return `dept_${dept}`;

  const map = {
    guard: "guard",
    weighbridge: "weighbridge",
    lab: "lab",
    accounts: "accounts",
    accounts_manager: "accounts",
    store_keeper: "store_keeper",
    supervisor: "supervisor",
    unloading_supervisor: "unloading_supervisor",
    production_loading_supervisor: "production_loading_supervisor",
    purchaser: "purchaser",
  };
  return map[role] || "operations";
}
